import gql from 'graphql-tag';

const VIEW_MAPPING_RECORDS = gql`
  query viewMappingRecords {
    viewMappingRecords
  }
`;

export default VIEW_MAPPING_RECORDS;
